module.exports = __webpack_public_path__ + "929ee1499f47cf52d47c363ee6e09e0e.svg";